import { Children, useId, useState } from 'react';

export default function EditorSections({ children, labels }) {
  const [active, setActive] = useState(0);
  const id = useId();
  function handleKeys(event) {
    let next = active;
    if (event.key === 'ArrowRight') next = (active + 1) % labels.length;
    else if (event.key === 'ArrowLeft') next = (active + labels.length - 1) % labels.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = labels.length - 1;
    else return;
    event.preventDefault();
    setActive(next);
    document.getElementById(`${id}-tab-${next}`)?.focus();
  }
  return <div className="editor-sections">
    <div className="manager-tabs editor-tabs" role="tablist" aria-label="Editor sections" onKeyDown={handleKeys}>
      {labels.map((label, index) => <button type="button" role="tab" key={label} id={`${id}-tab-${index}`} aria-controls={`${id}-panel-${index}`} aria-selected={active === index} tabIndex={active === index ? 0 : -1} onClick={() => setActive(index)}>{label}</button>)}
    </div>
    {Children.map(children, (child, index) => <div className="editor-section" role="tabpanel" id={`${id}-panel-${index}`} aria-labelledby={`${id}-tab-${index}`} hidden={active !== index} onInvalidCapture={event => {
      // Reveal invalid fields before moving focus; required fields may be on another tab.
      if (active !== index) {
        event.preventDefault();
        const input = event.target;
        setActive(index);
        requestAnimationFrame(() => { input.focus(); input.reportValidity(); });
      }
    }}>{child}</div>)}
  </div>;
}
